import { render } from "./LayoutHandler.vue?vue&type=template&id=3693bdc8&ts=true"
import script from "./LayoutHandler.vue?vue&type=script&lang=ts"
export * from "./LayoutHandler.vue?vue&type=script&lang=ts"

import exportComponent from "/Users/lyon/Desktop/Work s2j/app-rentalcar-project/admin-v3 2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__